// src/components/kpi/KpiFilters.jsx
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ENTITIES = [
  { code: "FR", label: "France" },
  { code: "DE", label: "Germany" },
  { code: "BE", label: "Belgium" },
  { code: "CH", label: "Switzerland" },
  { code: "US", label: "United States" },
  { code: "ES", label: "Spain" },
  { code: "UK", label: "Ireland & UK" },
  { code: "GR", label: "Greece" },
  { code: "IT", label: "Italy" },
];

const getCurrentPeriod = () => {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${d.getFullYear()}-${mm}`;
};

function toDateFromPeriod(p) {
  const m = String(p || "").match(/^(\d{4})-(\d{2})$/);
  if (!m) return new Date();
  return new Date(Number(m[1]), Number(m[2]) - 1, 1);
}

function toPeriodFromDate(d) {
  const y = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${y}-${mm}`;
}

function comparePeriod(a, b) {
  return String(a || "").localeCompare(String(b || ""));
}

export default function KpiFilters({
  country,
  setCountry,
  defaultCountry,
  period,
  setPeriod,
  onOpenFill,
  onOpenHelp,
  onRefresh,
  isEditablePeriod,
}) {
  const handleReset = () => {
    setPeriod(getCurrentPeriod());
    if (defaultCountry) setCountry(defaultCountry);
  };

  const entityLabel = ENTITIES.find((c) => c.code === country)?.label || country;

  const currentPeriod = getCurrentPeriod();
  const isPast = comparePeriod(period, currentPeriod) < 0;
  const isFuture = comparePeriod(period, currentPeriod) > 0;

  const isOwnEntity = !!country && !!defaultCountry && country === defaultCountry;

  let buttonLabel = "Add KPIs";
  let buttonDisabled = true;
  let buttonTitle = "";

  if (isPast) {
    buttonLabel = "Archived";
    buttonDisabled = true;
    buttonTitle = "Past period (read-only)";
  } else if (isFuture) {
    buttonLabel = "Future";
    buttonDisabled = true;
    buttonTitle = "Future period (read-only)";
  } else {
    buttonLabel = "Add KPIs";
    buttonDisabled = !(isEditablePeriod && isOwnEntity);
    if (!isOwnEntity) buttonTitle = "Not your entity";
    if (!isEditablePeriod) buttonTitle = "This period is closed";
  }

  return (
    <div className="kpi-filterbar">
      <h1 className="kpi-title">KPIs - {entityLabel}</h1>

      <div className="kpi-filterbar-right">
        <DatePicker
          className="kpi-select"
          popperClassName="kpi-datepicker-popper"
          calendarClassName="kpi-datepicker"
          selected={toDateFromPeriod(period)}
          onChange={(d) => d && setPeriod(toPeriodFromDate(d))}
          dateFormat="yyyy-MM"
          showMonthYearPicker
          maxDate={new Date()}
        />

        <select className="kpi-select" value={country} onChange={(e) => setCountry(String(e.target.value))}>
          {ENTITIES.map((c) => (
            <option key={c.code} value={c.code}>
              {c.label}
            </option>
          ))}
        </select>

        <button
          type="button"
          className="kpi-btn kpi-btn-primary"
          onClick={onOpenFill}
          disabled={buttonDisabled}
          title={buttonTitle}
        >
          {buttonLabel}
        </button>

        <button type="button" className="kpi-btn" onClick={onRefresh}>
          Refresh
        </button>

        <button type="button" className="kpi-btn" onClick={handleReset}>
          Reset
        </button>

        <button type="button" className="kpi-btn" onClick={onOpenHelp}>
          Help
        </button>
      </div>
    </div>
  );
}